import { IfpLoansAnalyticsContext } from '@sec-loans-ui/ifp-loans/analytics/analyticsContext'
import { ApplicantInfoStep } from '@sec-loans-ui/ifp-loans/steps/applicant-info/ApplicantInfoStep'
import { ConsentStep } from '@sec-loans-ui/ifp-loans/steps/consent/ConsentStep'
import { EndStep } from '@sec-loans-ui/ifp-loans/steps/end/EndStep'
import { FormContext } from '@sec-loans-ui/ifp-loans/steps/formContext'
import { GetApplicationStep } from '@sec-loans-ui/ifp-loans/steps/get-application/GetApplicationStep'
import { HouseholdInfoStep } from '@sec-loans-ui/ifp-loans/steps/household-info/HouseholdInfoStep'
import { IfpInfoStep } from '@sec-loans-ui/ifp-loans/steps/ifp-info/IfpInfoStep'
import { StatusStep } from '@sec-loans-ui/ifp-loans/steps/status/StatusStep'
import { AppId } from '@shared/types'
import { CommonWizardWrapper } from '@ui-common/components/CommonWizardWrapper'
import { use } from 'react'

import { useWizardLogic } from './useWizardLogic'
import { WizardContext, WizardStep } from './wizardMachine'

interface WizardProps {
  initialContext: Partial<WizardContext>
}

export const Wizard = ({ initialContext }: WizardProps) => {
  const { actor, ...formContext } = useWizardLogic(initialContext)

  const { analyticsService } = use(IfpLoansAnalyticsContext)
  const { step, exit, authToken, currentApplicantInfoIndex } = formContext

  const stepComponentMap: Partial<Record<WizardStep, () => React.ReactNode>> = {
    [WizardStep.GetApplicationStep]: () => <GetApplicationStep parentService={actor} />,
    [WizardStep.StatusStep]: () => <StatusStep />,
    [WizardStep.IfpInfoStep]: () => <IfpInfoStep />,
    [WizardStep.HouseholdInfoStep]: () => <HouseholdInfoStep />,
    [WizardStep.ApplicantInfoStep]: () => <ApplicantInfoStep key={currentApplicantInfoIndex} />,
    [WizardStep.ConsentStep]: () => <ConsentStep />,
    [WizardStep.EndStep]: () => <EndStep />,
  }

  return (
    <FormContext value={formContext}>
      <CommonWizardWrapper
        stepComponentMap={stepComponentMap}
        step={step}
        appId={AppId.SecLoans}
        analyticsService={analyticsService}
        onLogout={exit}
        authToken={authToken ?? null}
        userContext={null}
      />
    </FormContext>
  )
}
